import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

const Footer: React.FC = () => {
    const year = new Date().getFullYear();

    return (
        <footer className={styles.footer}>
            <div className={styles.container}>
                <div className={styles.grid}>
                    <div className={styles.brand}>
                        <h3>BDLINK LIVE</h3>
                        <p>বাংলাদেশে বিনামূল্যে লাইভ ক্রিকেট ও ফুটবল স্ট্রিমিং। মোবাইলে দ্রুত, সহজ, নির্ভরযোগ্য।</p>
                    </div>

                    <div>
                        <h4>নেভিগেশন</h4>
                        <ul>
                            <li><Link to="/">হোম</Link></li>
                            <li><Link to="/events">সব ম্যাচ</Link></li>
                            <li><a href="/#live">লাইভ ম্যাচ</a></li>
                            <li><a href="/#about">আমাদের সম্পর্কে</a></li>
                        </ul>
                    </div>

                    <div>
                        <h4>সাপোর্ট</h4>
                        <ul>
                            <li><a href="mailto:support@bdlink.live">support@bdlink.live</a></li>
                            <li>২৪/৭ সহায়তা</li>
                        </ul>
                    </div>
                </div>

                <div className={styles.bottom}>
                    <p>© {year} BDLINK LIVE. সর্বস্বত্ব সংরক্ষিত।</p>
                    <p className={styles.disclaimer}>
                        আমরা কোনো ক্রীড়া সংস্থা বা সম্প্রচারকের সাথে সংযুক্ত নই।
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
